import React, { useCallback } from "react";
import styled from "styled-components";
const Form = props => {
    const { disabled, onSubmit, innerRef } = props;
    const handleSubmit = useCallback((event) => {
        event.preventDefault();
        if (onSubmit && !disabled) {
            onSubmit(event);
        }
    }, [onSubmit, disabled]);
    return React.createElement("form", Object.assign({}, props, { onSubmit: handleSubmit, ref: innerRef }));
};
export default styled(Form) `
  box-sizing: border-box;
`;
